<template>
    <Form :validation-schema="schema" v-slot="{ handleSubmit, errors }" as="div">
        <div class="card">
            <div class="card-header">
                <span class="card-title p-0 m-0">General Information</span>
            </div>
            <div class="card-body">
                <div class="row g-3">
                    <div class="col-md-6">
                        <label for="name" class="form-label">Project Name <span class="text-danger">*</span></label>
                        <Field
                            type="text"
                            class="form-control"
                            name="name"
                            placeholder="Enter project name"
                            v-model="project.name"
                            :class="{ 'is-invalid': errors.name }"
                        ></Field>
                        <div v-if="errors.name" class="is-invalid invalid-feedback">{{ errors.name }}</div>
                    </div>
                    <div class="col-md-6">
                        <label for="customer" class="form-label">Client Name <span class="text-danger">*</span></label>
                        <Field
                            type="text"
                            class="form-control readonly disabled cursor-not-allowed"
                            name="client_name"
                            placeholder="Enter client name"
                            v-model="project.customer_name"
                            :class="{ 'is-invalid': errors.customer_name }"
                            readonly="readonly"
                        >
                        </Field>
                        <div v-if="errors.customer_name" class="is-invalid invalid-feedback">{{ errors.customer_name }}</div>
                    </div>
                    <div class="col-md-6">
                        <label for="email" class="form-label">Email <span class="text-danger">*</span></label>
                        <Field
                            type="email"
                            class="form-control readonly disabled cursor-not-allowed"
                            name="email"
                            placeholder="Enter email"
                            v-model="project.email"
                            :class="{ 'is-invalid': errors.email }"
                            readonly="readonly"
                        ></Field>
                        <div v-if="errors.email" class="is-invalid invalid-feedback">{{ errors.email }}</div>
                    </div>
                    <div class="col-md-6">
                        <label for="phone" class="form-label">Phone <span class="text-danger">*</span></label>
                        <Field
                            type="phone"
                            class="form-control readonly disabled cursor-not-allowed"
                            name="phone"
                            placeholder="Enter phone"
                            v-model="project.phone"
                            :class="{ 'is-invalid': errors.phone }"
                            readonly="readonly"
                        ></Field>
                        <div v-if="errors.phone" class="is-invalid invalid-feedback">{{ errors.phone }}</div>
                    </div>
                    <div class="col-md-6">
                        <label for="address" class="form-label">Address <span class="text-danger">*</span></label>
                        <Field
                            type="text"
                            class="form-control"
                            name="address"
                            placeholder="Enter address"
                            v-model="project.address"
                            :class="{ 'is-invalid': errors.address }"
                        ></Field>
                        <div v-if="errors.address" class="is-invalid invalid-feedback">{{ errors.address }}</div>
                    </div>
                    <div class="col-md-6">
                        <label for="address2" class="form-label">Address Two</label>
                        <Field
                            type="text"
                            class="form-control"
                            name="address2"
                            placeholder="Enter address two"
                            v-model="project.address2"
                            :class="{ 'is-invalid': errors.address2 }"
                        ></Field>
                        <div v-if="errors.address2" class="is-invalid invalid-feedback">{{ errors.address2 }}</div>
                    </div>
                    <div class="col-md-6">
                        <label for="city" class="form-label">City <span class="text-danger">*</span></label>
                        <Field
                            type="text"
                            class="form-control"
                            name="city"
                            placeholder="Enter city"
                            v-model="project.city"
                            :class="{ 'is-invalid': errors.city }"
                        ></Field>
                        <div v-if="errors.city" class="is-invalid invalid-feedback">{{ errors.city }}</div>
                    </div>
                    <div class="col-md-6">
                        <label for="state" class="form-label">State <span class="text-danger">*</span></label>
                        <Field
                            type="text"
                            class="form-control"
                            name="state"
                            placeholder="Enter state"
                            v-model="project.state"
                            :class="{ 'is-invalid': errors.state }"
                        ></Field>
                        <div v-if="errors.state" class="is-invalid invalid-feedback">{{ errors.state }}</div>
                    </div>
                    <div class="col-md-6">
                        <label for="postal_code" class="form-label">Postal Code <span class="text-danger">*</span></label>
                        <Field
                            type="text"
                            class="form-control"
                            name="postal_code"
                            placeholder="Enter postal code"
                            v-model="project.postal_code"
                            :class="{ 'is-invalid': errors.postal_code }"
                        ></Field>
                        <div v-if="errors.postal_code" class="is-invalid invalid-feedback">{{ errors.postal_code }}</div>
                    </div>
                    <div class="col-md-3">
                        <label for="tender_amount" class="form-label">Tender Amount <span class="text-danger">*</span></label>
                        <Field
                            type="text"
                            class="form-control"
                            name="tender_amount"
                            placeholder="Enter tender amount"
                            v-model="project.tender_amount"
                            :class="{ 'is-invalid': errors.tender_amount }"
                        ></Field>
                        <div v-if="errors.tender_amount" class="is-invalid invalid-feedback">{{ errors.tender_amount }}</div>
                    </div>
                    <div class="col-md-3">
                        <label for="avg_staff_cost" class="form-label">Average Staff Cost</label>
                        <Field
                            type="text"
                            class="form-control"
                            name="avg_staff_cost"
                            placeholder="Enter average staff cost"
                            v-model="project.avg_staff_cost"
                            :class="{ 'is-invalid': errors.avg_staff_cost }"
                        ></Field>
                        <div v-if="errors.avg_staff_cost" class="is-invalid invalid-feedback">{{ errors.avg_staff_cost }}</div>
                    </div>
                    <div class="col-md-6">
                        <label for="start_date" class="form-label">Start Date <span class="text-danger">*</span></label>
                        <Field
                            class="form-control"
                            name="start_date"
                            :value="project.start_date"
                            v-slot="{ field }"
                        >
                            <VueDatePicker
                                v-bind="field"
                                v-model="project.start_date"
                                :enable-time-picker="false"
                                :format="'dd-MM-yyyy'"
                            >
                            </VueDatePicker>
                        </Field>
                        <div v-if="errors.start_date" class="is-invalid invalid-feedback">{{ errors.start_date }}</div>
                    </div>
                    <div class="col-md-6">
                        <label for="end_date" class="form-label">End Date <span class="text-danger">*</span></label>
                        <Field
                            class="form-control"
                            name="end_date"
                            :value="project.end_date"
                            v-slot="{ field, meta  }"
                        >
                            <VueDatePicker
                                v-bind="field"
                                v-model="project.end_date"
                                :enable-time-picker="false"
                                :format="'dd-MM-yyyy'"
                                :min-date="project.start_date"
                            >
                            </VueDatePicker>
                        </Field>
                        <div v-if="errors.end_date" class="is-invalid invalid-feedback">{{ errors.end_date }}</div>
                    </div>

                    <div class="col-12">
                        <button
                            type="button"
                            class="btn btn-theme float-end"
                            :class="{ 'disabled': processing }"
                            :disabled="processing"
                            v-text="processing ? 'Processing...' : 'Update'"
                            @click="handleSubmit($event, updateProject)"
                        ></button>
                    </div>
                </div>
            </div>
        </div>
    </Form>
</template>
<script>
export default {
    name: 'EditProject',
    props: {
        projectDetails: Object,
        default: () => ({})
    },
    data() {
        return {
            processing: false,
            customerOptions: [],
            project: {
                name: '',
                customer: '',
                customer_name: '',
                email: '',
                phone: '',
                address: '',
                address2: '',
                city: '',
                county: '',
                state: '',
                postal_code: '',
                amount: '',
                tender_amount: '',
                avg_staff_cost: '',
                start_date: new Date(),
                end_date: new Date(new Date().setDate(new Date().getDate() + 5)),
                customer_select:null,
                users: [
                    {
                        id: '',
                        name: '',
                        email: '',
                        labour_cost: '',
                        user_select: null,
                        work_date: new Date(),
                    }
                ]
            },
            staffUsers: [],
        }
    },
    computed: {
        schema() {
            return {
                name: 'required',
                address: 'required',
                city: 'required',
                state: 'required',
                postal_code: 'required',
                tender_amount: 'required',
                start_date: 'required',
                end_date: 'required',
            }
        }
    },
    mounted() {
        this.project.name = this.projectDetails.name;
        this.project.customer = this.projectDetails.customer.id;
        this.project.customer_name = this.projectDetails.customer.name;
        this.project.email = this.projectDetails.customer.email;
        this.project.phone = this.projectDetails.customer.phone_number;
        this.project.address = this.projectDetails.address;
        this.project.address2 = this.projectDetails.address2;
        this.project.city = this.projectDetails.city;
        this.project.county = this.projectDetails.county;
        this.project.state = this.projectDetails.state;
        this.project.postal_code = this.projectDetails.postal_code;
        this.project.amount = this.projectDetails.tender_amount;
        this.project.avg_staff_cost = this.projectDetails.average_staff_cost;
        this.project.tender_amount = this.projectDetails.tender_amount;
        this.project.start_date = this.projectDetails.start_at;
        this.project.end_date = this.projectDetails.ends_at;
    },
    methods: {
        updateProject() {
            this.processing = true;
            let self = this;
            axios.patch('/admin/projects/' + this.projectDetails.id, self.project)
                .then(response => {
                    if (response.data.status == 'success') {
                        window.location.href = response.data.redirect_url;
                    }
                });
        }
    }
}
</script>
